import { Module } from '../Module';
import { ISchedule, ScheduleActions, ScheduleActionsState } from '../ServerApi/types/ISchedule';

export class SchedulesConfig {

  public static $inject = ['$state'];

  constructor(private $state:ng.ui.IStateService) {
  }

  public siteUrlFor(schedule: ISchedule) {
    return this.$state.href('main.site.schedule.' + this.defaultChildState(schedule), { id: schedule.id });
  }

  public serverUrlFor(schedule: ISchedule) {
    return this.$state.href('main.server.schedule.' + this.defaultChildState(schedule), { id: schedule.id });
  }

  private defaultChildState(schedule: ISchedule): string {
    let state = '';
    switch (schedule.scheduledAction) {
      case ScheduleActions.Extract: {
        state = ScheduleActionsState.Extracts;
        break;
      }
      case ScheduleActions.Subscription: {
        state = ScheduleActionsState.Subscriptions;
        break;
      }
      case ScheduleActions.Flow: {
        state = ScheduleActionsState.Flows;
        break;
      }
    }
    return state;
  }

}

Module.instance().service('SchedulesConfig', SchedulesConfig);
